<template>
    <div class="icon"
        v-if="src"
        :style="style">
        <img :src="src"
            :alt="alt" />
    </div>
</template>

<script>
    export default {
        name: 'Icon',
        props: {
            name: {
                type: String,
                required: true
            },
            type: { // 图片后缀
                type: String,
                default: 'svg'
            },
            alt: {
                type: String
            },
            width: {
                type: Number,
                required: true
            },
            height: {
                type: Number,
                required: true
            }
        },
        computed: {
            style () {
                return {
                    width: `${this.width}px`,
                    height: `${this.height}px`
                }
            },
            src () {
                if (this.name) {
                    const imgName = `${this.name}.${this.type}`
                    return require(`./img/${imgName}`)
                }
                return ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon {
        img {
            width: 100%;
            height: 100%;
        }
    }
</style>
